import { UserDataFragment } from "@bonliva-crm/graphql";
import { CallOrContactList } from "@consultants/consultant-profile-new/call-list/utils";
import * as yup from "yup";
import { getSmsTextHint } from "@components/sms/sms-text-hint";

export type ReassignBaActionFormValues = {
  responsiblePerson: UserDataFragment;
  resetResponsiblePerson: boolean;
};

export const reassignBaFormSchema = yup.object({
  responsiblePerson: yup
    .object({
      _id: yup.string().required(),
      Name: yup.string().required()
    })
    .noUnknown(false)
    .nullable(true),
  resetResponsiblePerson: yup.boolean().when("responsiblePerson", {
    is: null,
    then: yup.boolean().oneOf([true])
  })
});

export type ConsultantAssignTagsActionFormValues = {
  tags: string[];
};

export const consultantAssignTagsActionFormSchema = yup.object({
  tags: yup.array(yup.string().required()).required()
});

export type SMSActionFormValues = {
  recipients: { phone: string; name: string }[];
  message: string;
};

/** `maxLength` is the bulk limit, which leaves room for the unsubscribe link. */
export const smsActionFormSchema = (maxLength: number) =>
  yup.object({
    recipients: yup
      .array(
        yup.object({
          phone: yup.string().required(),
          name: yup.string().required()
        })
      )
      .required(),
    message: yup
      .string()
      .required()
      .nullable(false)
      // yup 0.24 reads a function in the message slot as the test itself, so the
      // message must be a string; the reason comes from createError instead.
      .test("sms-text", "", function (value) {
        const hint = getSmsTextHint(value, maxLength);
        return (
          hint.valid || this.createError({ path: this.path, message: hint.error ?? "" })
        );
      })
  });

export type ConsultantAssignCallListFormValues = {
  callOrContactLists: CallOrContactList[];
};

export const consultantAssignCallListActionFormSchema = yup.object({
  callOrContactLists: yup
    .array(
      yup
        .object({
          _id: yup.string().required(),
          name: yup.string().required()
        })
        .noUnknown(false)
    )
    .required()
});
